enum WorkSafeBcRehabilitationProgram {
    WCP = 1,
    Other
}

export { WorkSafeBcRehabilitationProgram };
